import { getUnsplashImages as _getUnsplashImages } from '@griply/services';
import { UnsplashImage } from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

export const getUnsplashImages = (
  searchText: string,
  page: number,
  pageSize: number,
): Promise<UnsplashImage[]> =>
  _getUnsplashImages({
    functions: getFunctions(),
    httpsCallable,
    payload: { searchText, page, pageSize },
  });
